// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: 790158202
// </auto-generated>
import {
  StringLength,
  RegularExpression,
  Required,
  EmailAddress,
  MinValue,
} from 'carehub-shared/validators';
import { Address } from '../../models/anesthesiologist/address';
import { Document } from '../../models/anesthesiologist/document';

export class Anesthesiologist {
  @Required()
  anesthesiologistId: string;
  contractTypeId: number;
  metroAreaId: number;
  @StringLength(255)
  email: string;
  @StringLength(50)
  fax: string;
  @Required()
  isActive: boolean;
  @Required()
  @StringLength(256)
  name: string;
  @StringLength(3000)
  notes: string;
  @StringLength(10)
  npi: string;
  @StringLength(50)
  phone: string;
  @StringLength(16)
  tin: string;
  inactiveDate: Date | string;
  createdUserId: string;
  updatedUserId: string;
  createdDate: Date | string;
  updatedDate: Date | string;
  addresses: Address[];
  documents: Document[];
}

export function initializeNewAnesthesiologist(): Anesthesiologist {
  const instance = new Anesthesiologist();
  instance.anesthesiologistId = '00000000-0000-0000-0000-000000000000';
  instance.contractTypeId = null;
  instance.metroAreaId = null;
  instance.email = '';
  instance.fax = '';
  instance.isActive = false;
  instance.name = '';
  instance.notes = '';
  instance.npi = '';
  instance.phone = '';
  instance.tin = '';
  instance.inactiveDate = null;
  instance.createdUserId = '00000000-0000-0000-0000-000000000000';
  instance.updatedUserId = '00000000-0000-0000-0000-000000000000';
  instance.createdDate = null;
  instance.updatedDate = null;
  instance.addresses = null;
  instance.documents = null;
  return instance;
}
